import { render, staticRenderFns } from "./Xbalance.vue?vue&type=template&id=3dfba232&"
import script from "./Xbalance.vue?vue&type=script&lang=js&"
export * from "./Xbalance.vue?vue&type=script&lang=js&"
import style0 from "./Xbalance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports